import { render } from "./EventListView.vue?vue&type=template&id=2cee243c&scoped=true&ts=true"
import script from "./EventListView.vue?vue&type=script&lang=ts"
export * from "./EventListView.vue?vue&type=script&lang=ts"

import "./EventListView.vue?vue&type=style&index=0&id=2cee243c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cee243c"]])

export default __exports__